import { Component, OnInit } from '@angular/core';
import { aspMngr } from '@core_n/asp/AspMngr';
import { ObjectType } from '@core_n/asp/AspObject';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { AppInjector } from '@core_n/common/inject';
import { dialogType } from '@core_n/enums';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { SensorObject } from 'src/app/asp/SensorObject';
import * as consts from '../common/consts';
import * as utils from '../common/utils';

@Component({
  selector: 'alert-list',
  templateUrl: './alert-list.component.html',
  styleUrls: ['./alert-list.component.scss']
})
export class AlertListComponent implements OnInit {

  constructor() {}
    

    errorsList = new Array<any>();


  // const MAX_SEARCH_RESULTS = 100;
  // const HIGHLIGHT_COLOR = 'orange';
  
    
    static createDialogConfig(upperBarHeight: number) {
      return utils.createDialogConfig(false, false, dialogType.showErrors,
        { top: `${upperBarHeight + 5}px`, right: `80px` });
    }
  
    ngOnInit() {
      this.errorsList = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION));
      setInterval(() => this.refresh() , consts.DIALOG_REFRESH_INTERVAL);
    }
    
    ngOnDestroy(): void {
      localStorage.setItem(consts.LOCAL_STORAGE_NEW_ERR_NOTIFICATION, JSON.stringify(false));
      if (this.errorsList) {
        this.errorsList.map(u => u.isNew == true ? u.isNew = false : u.isNew = false);
        localStorage.setItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION, JSON.stringify(this.errorsList));
      }
    }
  
    protected refresh(): void {
      let list = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION));
      if (!list) {
        this.errorsList = [];
        return;
      }
      this.errorsList = list;
    }
  
    setCenter(cameraName: string) {
      let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
      if (!sensor)
        sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");     
      mainMapMngr.setMapCenter(sensor.geometry);
    }
  
    openAro(cameraName: string) {
      let sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
      if (!sensor)
        sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((cameraName.toLowerCase()).toLowerCase() + ".stream");    
      AppInjector.get(AroSensorService).showWindow(sensor as SensorObject);
    }
  
    deleteAll() {
      localStorage.removeItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION);
    }

}
